module.exports = __webpack_public_path__ + "img/table-fl-icon.2173734a.svg";